(function () {
  'use strict';

  var dialog = document.querySelector('[data-pp-new-pages-launch]');
  if (!dialog) return;

  var storageKey = dialog.getAttribute('data-storage-key');
  var forcePreview = false;

  try {
    var preview = new URLSearchParams(window.location.search);
    forcePreview =
      preview.get('show-place-reward') === '1' ||
      preview.get('show-new-pages') === '1';
  } catch (error) {
    forcePreview = false;
  }

  forcePreview = forcePreview || document.documentElement.classList.contains('shopify-design-mode');

  function hasSeenAnnouncement() {
    if (forcePreview) return false;

    try {
      return window.localStorage.getItem(storageKey) === '1';
    } catch (error) {
      return false;
    }
  }

  function rememberAnnouncement() {
    try {
      window.localStorage.setItem(storageKey, '1');
    } catch (error) {
      // Storage can be unavailable in private browsing. Closing still works.
    }
  }

  function openAnnouncement() {
    if (dialog.open || hasSeenAnnouncement()) return;

    document.documentElement.classList.add('pp-launch-open');

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeAnnouncement() {
    rememberAnnouncement();
    document.documentElement.classList.remove('pp-launch-open');

    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  dialog.querySelectorAll('[data-pp-launch-close]').forEach(function (button) {
    button.addEventListener('click', closeAnnouncement);
  });

  dialog.querySelectorAll('[data-pp-launch-destination]').forEach(function (link) {
    link.addEventListener('click', rememberAnnouncement);
  });

  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    closeAnnouncement();
  });

  dialog.addEventListener('close', function () {
    document.documentElement.classList.remove('pp-launch-open');
  });

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) closeAnnouncement();
  });

  window.setTimeout(openAnnouncement, forcePreview ? 0 : 900);
})();
